import isEmpty from "../../validation/is-empty";
import {
  CHK_PAYMENT_DETAILS_SUCCESS,
  CHK_PAYMENT_DETAILS_FAILED,
  CHK_PAYMENT_DETAILS_LOADING,
  CHK_RESET_PAYMENT_DETAILS,
  CHK_NETWORK_ERROR_PAYMENT_DETAILS,
  CHK_SET_OPTION,
  PAY_SUCCESS,
  CHK_SET_TRACKINGID
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  networkError: false,
  data: {},
  description: '',
  payOption: '',
  trackingId: '',
  checkoutFinalStatus: ''
};

export default (state = initialState, action) => {
  switch (action.type) {

    case CHK_PAYMENT_DETAILS_LOADING:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        networkError: false,
        data: {},
        description: "",
        payOption: ''
      };

    case CHK_PAYMENT_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        networkError: false,
        data: action.payload,
        description: action.payload.status,
        payOption: action.payload.payOption
      };

    case CHK_PAYMENT_DETAILS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        networkError: false,
        data: action.payload,
        description: action.payload.status
      };

    case CHK_NETWORK_ERROR_PAYMENT_DETAILS:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        networkError: true,
        data: action.payload,
        description: "Cannot connect to the server !"
      };


    case CHK_SET_OPTION:
      return {
        ...state,
        payOption: action.payload
      }

    case CHK_SET_TRACKINGID:
      return {
        ...state,
        trackingId: action.payload
      }

    case PAY_SUCCESS:
      return {
        ...state,
        payOption: action.payload.payOption || ""
      }

    case CHK_RESET_PAYMENT_DETAILS:
      return (state = initialState);


    default:
      return state;
  }
};
